import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0befc4d9"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "electricity-unit-rate"
}
const _hoisted_2 = { class: "electricity-unit-rate__title h4" }
const _hoisted_3 = { class: "electricity-unit-rate__description" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-arrow-right" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_InputField = _resolveComponent("InputField")!
  const _component_RadioGroup = _resolveComponent("RadioGroup")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_ctx.pageContent)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.pageContent.title), 1),
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.pageContent.description), 1),
        _createVNode(_component_RadioGroup, {
          modelValue: _ctx.isUnitRateExact,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isUnitRateExact) = $event)),
          class: "electricity-unit-rate__unit-rate-type"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_RadioButton, {
              value: true,
              label: _ctx.pageContent.exactAmountButtonCopy,
              "input-id": "is-unit-rate-exact"
            }, null, 8, ["label"]),
            (_ctx.isUnitRateExact)
              ? (_openBlock(), _createBlock(_component_InputField, {
                  key: 0,
                  ref: "unit-rate-input",
                  modelValue: _ctx.exactUnitRate,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.exactUnitRate) = $event)),
                  "has-error": _ctx.isUnitRateOutOfRange,
                  "error-message": _ctx.unitRateErrorMessage,
                  label: "Amount (p/kWh)",
                  name: "exact-unit-rate-p-per-kwh",
                  type: "number",
                  required: ""
                }, null, 8, ["modelValue", "has-error", "error-message"]))
              : _createCommentVNode("", true),
            _createVNode(_component_RadioButton, {
              value: false,
              label: _ctx.pageContent.nationalAverageButtonCopy,
              "input-id": "is-unit-rate-estimated"
            }, null, 8, ["label"])
          ], undefined, true),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_AppButton, {
          class: "electricity-unit-rate__next-button",
          disabled: !_ctx.unitRateSelected,
          "full-width": "",
          onClick: _ctx.next
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_ctx.nextStepButtonCopy), 1),
            _hoisted_4
          ], undefined, true),
          _: 1
        }, 8, ["disabled", "onClick"])
      ]))
    : _createCommentVNode("", true)
}